import styles from '@/styles/topReview/topReviewItem.module.scss'
import Image from 'next/image'
import Link from 'next/link'
import { useState } from 'react';
import { Rate, Button, message } from 'antd'
import useCartActions from '@/utils/addTocartAction'
import { getToken } from '@/utils/auth'
import { localStorageService } from "@/utils/storageService"

import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();
const apiDomain = publicRuntimeConfig.apiDomain;

interface ProductItem {
  productID: string;
  name: string;
  url: string;
  imgUrl: string;
  reviewCount: number;
  price: number;
  normalPrice: number;
  freeShipping: number;
  onSale: number;
  reduced: number;
  isNew: number;
  position?: number,
  location?: string;
  isEmailOnly: any;
  inStock?: number;
  isGroup?: number;
  preSales?: number;
  promotionTypeID: string | number;
  promotion: {
    productID: number;
    promotionType: number;
    promotionPrice: number;
    normalPrice: number;
    endDate: string;
    status: number;
    notified: number;
    pointRate: string;
    promotionRate: number;
  };
  review: {
    avgRank: number;
    total: number;
  };
  shortDescription?: string;
}

export default function TopReviewItem(props: ProductItem) {
  const { addToCart } = useCartActions();
  const [btnLoading, setBtnLoading] = useState(false)

  const addToCartCallBack = () => {
    setBtnLoading(false)
    window.location.href = "/view-cart"
  }

  const preOrder = async (event: any) => {
    event.stopPropagation()
    setBtnLoading(true)
    const isLogin = getToken() == '1'
    const pid = props.productID
    if (!isLogin) {
      location.href = '/login?redirect=' + encodeURIComponent('/checkout?p=' + pid + '&t=' + 1);
      return false;
    }
    location.href = '/checkout?p=' + pid + '&t=1';
  }

  return (
    <>
      <div className={styles['comp-top-review-item-box']}>
        <Link 
          href={`${props.url}`}
          passHref
          legacyBehavior
        >
          <a 
            rel="noopener noreferrer"
          >
            <div className={styles['comp-top-review-item']}>
              <div className={styles['product-box']}>
                <Image
                  className={styles['product-img']}
                  src={props.imgUrl}
                  alt={props.name}
                  width={217}
                  height={217}></Image>

                <div className={styles['product-info']}>
                  <div className={styles['product-content']}>
                    <div className={styles['content-left']}>
                      <div className={styles['product-name']}>
                        {props.name}
                      </div>

                      <div className={styles['product-review-range']}>
                        <Rate style={{ fontSize: '16px', color: '#ffc33d' }} allowHalf disabled value={props.review.avgRank} />
                        &nbsp;({props.review.total})
                      </div>
                    </div>

                    {
                      props.promotion?.promotionRate &&
                      <div className={styles['product-discount']}>
                        <div className={styles['discount-num']}>
                          {props.promotion?.promotionRate}
                        </div>
                        <div className={styles['discount-text']}>
                          <div className={styles['discount-unit']}>%</div>
                          <div className={styles['discount-off']}>OFF</div>
                        </div>
                      </div>
                    }
                  </div>

                  <div className={styles['review-content']}>
                    {props?.shortDescription}
                  </div>
                </div>
              </div>

              <div className={styles['operation-box']}>
                <div className={styles['price-info']}>
                  <div className={styles['price']}>
                    ${props.price}
                  </div>
                  {
                    !!(props.normalPrice && props.price !== props.normalPrice) &&
                    <div className={styles['normal-price']}>
                      ${props.normalPrice}
                    </div>
                  }
                </div>
              </div>
            </div>
          </a>
        </Link>

        {
          props.preSales
          ?
          <Button 
            className={styles['pre-order-btn']} 
            onClick={preOrder}
            loading={btnLoading}
          >
            PRE-ORDER
          </Button>
          :
          <>
            {
              (props.inStock && props.isGroup == 0) 
              ?
              <Button 
                className={styles['add-to-cart']} 
                onClick={
                  (event) => { 
                    setBtnLoading(true); 
                    addToCart(
                      event, 
                      { 
                        productID: props.productID, 
                        qty: 1
                      }, 
                      addToCartCallBack
                    ) 
                  }
                }
                loading={btnLoading}
              >
                Add to Cart
              </Button>
              :
              <Button 
                className={styles['add-to-cart']}
                type="primary"
                href={`${props.url}`}
              >
                Notify Me
              </Button>
            }
          </>
        }
      </div>
    </>
  )
}